module Meevo.Plugins.PayInOutReasons {
  "use strict";

  /**
  * Main Section of PayInOutReasons 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.PayInOutReasons> {

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
      createSectionModelInstance(postAdd:(data:any)=>any): void {
          this.dataService.getTemplate(this.baseEndpoint).then((data) => {
              this.model = data;
          });
      }
   
  }

}